import React from 'react'

import ImageWithText from '@/components/flows/WalkthroughFlow/components/ImageWithText'
import screenshotUrl from '@/components/flows/WalkthroughFlow/steps/3_ReferralEngineScreen2/screenshot.png'

const ReferralEngineScreen2: React.FC = () => (
  <ImageWithText
    imageUrl={screenshotUrl}
    text={
      <p className="mb-4">
        Referring a client is quick and compliant. Pick the firm, add the
        details, and a referral case is created—complete with updates, messages,
        and documents.
      </p>
    }
  />
)

export default ReferralEngineScreen2
